export default __webpack_public_path__ + "static/media/telunjuk.7d0883c4.mp3";